import {makeStyles} from "@material-ui/core/styles"
import {Box, TextField} from "@material-ui/core"
import {Autocomplete} from "@material-ui/lab"
import React from "react"
import UserEvent from "../../core/UserEvent"
import lang from "../../core/lang"
import i18n from "../../core/i18n";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        paddingLeft: '0.3em',
        paddingRight: '0.3em',
    },
    input: {
        paddingTop: '0px !important',
        paddingBottom: '0px !important',
        fontSize: '0.8em',
    },
    option: {
        fontSize: '0.8em',
    }
}))

function SelectToolButton(props) {
    const {value, style = {}, options, onClick, 'aria-label': ariaLabel} = props
    const classes = useStyles()

    const handleChange = (event, newValue) => {
        event.preventDefault()
        const value = newValue
        onClick && onClick(new UserEvent({value}, event))
    }

    const title = i18n.translate(props.title)

    return (
        <Box display="flex" flexDirection="row" alignItems="center">
            <Autocomplete classes={classes} style={style}
                          size="small"
                          value={value}
                          onChange={handleChange}
                          selectOnFocus
                          clearOnBlur
                          handleHomeEndKeys
                          options={options}
                          getOptionLabel={(option) => {
                              // Value selected with enter, right from the input or options are primitive
                              if(lang.isPrimitive(option)) {
                                  return option.toString()
                              }
                              return option.text
                          }}
                          getOptionSelected={option => {
                              if(lang.isPrimitive(option)) {
                                  return option === value
                              } else {
                                  return option.value === value
                              }
                          }}
                          renderOption={option => {
                              if(lang.isPrimitive(option)) {
                                  return option.toString()
                              } else {
                                  return option.text
                              }
                          }}
                          freeSolo
                          title={title} aria-label={i18n.translate(ariaLabel) || title}
                          renderInput={(params) => <TextField {...params} classes={undefined} variant="outlined"/>}
            />
        </Box>
    )
}

SelectToolButton.propTypes = {
    value: PropTypes.any,
    options: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.shape({
                value: PropTypes.any,
                text: PropTypes.string
            }),
            PropTypes.any
        ])
    ),
    style: PropTypes.object,
    onClick: PropTypes.func,
    title: PropTypes.string,
    'aria-label': PropTypes.string,
}

export default SelectToolButton